import React from "react";
import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";

export const OutputPropertiesPanel: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 mb-4">
        <Icon className="w-5 h-5 text-green-500" icon="solar:check-circle-linear" />
        <h3 className="text-sm font-semibold">{t("Output Node")}</h3>
      </div>

      <p className="text-xs text-default-500">
        {t(
          "The output node represents the final result of the workflow. It automatically receives data from the last agent or team in the pipeline.",
        )}
      </p>

      <div className="p-3 rounded-lg bg-green-50 dark:bg-green-900/20">
        <p className="text-xs text-green-700 dark:text-green-300">
          {t("Connect agents or teams to this node to define the workflow's final output.")}
        </p>
      </div>
    </div>
  );
};
